// extracted by mini-css-extract-plugin
module.exports = {"Errors":"BusinessInformationForm_Errors__200w4"};